<template>
  <div class="container" v-wechat-title="'这是是动态'">
    <Tabs :data="tabs" />
    <Map />
  </div>
</template>

<script>
import Tabs from '../components/Tabs'
export default {
  name: 'Guide',
  components: {
    Tabs
  },
  data: () => ({
    tabs: [
      { id: 0, name: '导览' },
      { id: 1, name: '卫生间' },
      { id: 2, name: '出入口' },
      { id: 3, name: '服务点' }
    ]
  })
}
</script>

<style lang="scss" scoped>
  .container {
    height: 100vh;
    background-color: #f5f5f5;
  }
</style>
